'use client';
import { Suspense, useState } from 'react';
import CategoryBannerSwiper from './CategoryBannerSwiper';
import { IPost } from '../../../models/ICategory';
import FallBackImage from '../FallBackImage';
import Link from 'next/link';
import CategorySwiper from './CategoryBannerSwiper';

interface Props {
  locale: string;
  data: {
    posts: IPost[];
    category: {
      uniqueCode: string;
      title: string;
      isLink?: boolean;
    }
  };
  device?: string;
}

export default function CategoryBanner({ data, locale, device }: Props) {


  const [selected, setSelected] = useState(0);
  const item = data.posts[selected];
  if (!item) return null;
  return (
    <div className='flex flex-col h-[calc(80vh-71px)] tablet:h-[unset] tablet:aspect-[16/9] desktop:aspect-[unset] w-full mb-[60px]'>
      <Link className='h-full relative tablet:aspect-[16/9]' hrefLang={locale} title={item.title} href={`/${data.category.uniqueCode}/${item.uniqueCode}`}>

<FallBackImage device={device} src={item.image} customDimensions={{width: 390 * 2, height: 466 * 2, fit: 'cover'}} thumbnail={item.thumbnail} key={item.image} fill priority alt={item.imageAlt || ''} className='absolute top-0 left-0 object-cover h-full w-full' />
        <div className='flex flex-col relative justify-end h-full px-[34px] py-[16px]'>
          <div className='absolute bottom-0 left-0 h-[85%] tablet:h-[40%] w-full bg-gradient-banner dark:bg-gradient-banner-dark' />
          <div className='flex flex-col gap-y-[20px]'>
            {data.category.isLink ? 
                  <Link className='tag h5 font-medium tablet:font-kufi-600 z-[2]' hrefLang={locale} title={data.category.title} href={`/${data.category.uniqueCode}`}>
                    {data.category.title}
                  </Link>
            : 
            <h1 className='tag h4 font-medium tablet:font-kufi-600 !cursor-default' onClick={e => e.stopPropagation()}>{data.category.title}</h1>}
            <span className='text-white h1 desktop:max-w-[85%] h1'>{item.title}</span>
          </div>
        </div>
      </Link>

      <div className='flex items-center justify-center gap-x-[30px] h-[150px] bg-primary-300 dark:bg-night-100 py-[24px]  desktop:rounded-br-[12px] desktop:rounded-bl-[12px]'>
        <Suspense fallback={<></>}>
          <CategorySwiper
            selected={selected}
            locale={locale}
            data={{
              posts: data.posts!,
              category: data.category
            }}
            setSelected={(idx: number) => setSelected(idx)}
            device={device}
          />
        </Suspense>
      </div>
    </div>



  )
}  